import { Loader2 } from "lucide-react";
import { twMerge } from "tailwind-merge";

type SpinnerAlignment = "fixedCentered" | "absoluteCentered" | null;

interface SpinnerProps {
  className?: string;
  alignment?: SpinnerAlignment;
}

export function Spinner({ className, alignment = null }: SpinnerProps) {
  return (
    <Loader2
      className={twMerge(
        "text-action mx-auto size-6 animate-spin",
        alignment === "fixedCentered" &&
          "fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
        alignment === "absoluteCentered" &&
          "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
        className,
      )}
    />
  );
}
